// src/views/intro.ts
import { html, type TemplateResult } from 'lit-html';
import { showConfirm } from '../components/modal.js';
import type { Store } from '../modules/store.js';
import type { Router } from '../modules/router.js';

interface RenderIntroParams {
  store?: Store;
}

export function renderIntro(_params: RenderIntroParams = {}): TemplateResult {
  return html`
    <div class="container">
      <h2>选择题库</h2>
      <p class="subtitle">两套题库的计分方法相同,差异在题目情景。</p>

      <div class="qchoice">
        <button class="qcard" data-q="A">
          <div class="qcard-title">📘 题库 A · VARK 官方 v8 (中译)</div>
          <p>来源:Neil Fleming · vark-learn.com</p>
          <p class="qcard-meta">每题旁可查看英文原文 · 仅供个人与教学非商业用途</p>
        </button>
        <button class="qcard" data-q="B">
          <div class="qcard-title">📗 题库 B · 自研中文 v1</div>
          <p>本项目自研,基于 VARK 四维度模型</p>
          <p class="qcard-meta">完全中文情景 · MIT 许可</p>
        </button>
      </div>

      <details class="notice">
        <summary>答题须知</summary>
        <ul>
          <li>共 16 道情景题,每题至少选 1 项,可多选 (VARK 标准做法)</li>
          <li>答题中途可回到任意已答题修改</li>
          <li>答题进度自动保存到本浏览器</li>
        </ul>
      </details>

      <p><a href="#/">← 回首页</a></p>
    </div>
  `;
}

export function bindIntro(root: HTMLElement, store: Store, router: Router): void {
  root.querySelectorAll<HTMLButtonElement>('.qcard').forEach(btn => {
    btn.addEventListener('click', async () => {
      const q = btn.dataset.q as 'A' | 'B' | undefined;
      if (!q) return;
      if (store.state.status === 'in_progress' && store.state.questionnaire !== q) {
        const ok = await showConfirm('切换题库会清空当前进度,确定继续?');
        if (!ok) return;
      }
      store.startSession(q);
      router.navigate('/test');
    });
  });
}
